export const muteNotifications = 'muteNotifications';
export const muteString = 'mute';
export const muteSuccess = 'set mute to ';
export const muteError = 'Error muting service';
export const unmuteString = 'unmute';
